import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
  ElementType,
  NumberFormat,
  SelectCombos,
  PabsMoreInfoPanels,
} from '../Enums/constants';


export const PabsUkCostsTab = () => {
  return (
    <SurveyPage pageName='Cost'>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText=''>
          <SurveyElement
            questionNumber='3'
            labelText='Attribute your total pension administration costs and staff in the table below.'
            note='Exclude investment related costs/staff and pension protection fund levies. Refer to either the Help icon at the top right corner of this page or by pointing at the help bubbles next to each function for further guidance.'
          />
          <SurveyElement inputType='grid' styleName={'dataTable'}>
            <SurveyGridHeader>
              <SurveyElement
                labelText='Functions'
                inputType={ElementType.LABEL}
                name=''
              />
              <SurveyElement
                labelText='Direct Full Time Equivalent Internal Staff (# of FTE)'
                inputType={ElementType.LABEL}
                tooltip='left'
                helpText="Instructions for this column - Direct full time equivalent (FTE) internal staff <br/><br/> Attribute internal staff to the activities that they primarily perform.<br/><br/>
                                    Personal assistants / secretaries should be included in the headcount for the activity they support (or follow the people / team that they support).  For example, the PA to the head of pensions administration should be included in the administration FTE and staff cost.
                                    <br/><br/>If a person's time is split between multiple activities then split his FTE based on the approximate time spent on each activity. (i.e., if a person spends 60% of time on administration and 40% on communication then 0.6 FTE to administration and 0.4 FTE to communication) 
                                    <br/><br/>Do not include the full-time-equivalent of staff, if any, whose salaries are being capitalised."
              />
              <SurveyElement
                labelText='Staff Salaries & Benefits (£000s)'
                inputType={ElementType.LABEL}
                tooltip='left'
                helpText='<span> Instructions for this column - Staff salaries and benefits</span> <br/><br/> <span>Supply the staff costs for the full time equivalent staff identified in the first column.</span> <br/><br/> <span>Staff costs include compensation (salary, wages, overtime, bonuses), benefits (cars, pensions) and National Insurance.</span>'
              />
              <SurveyElement
                labelText='Third Party Fees and Other Direct Costs (£000s)'
                tooltip='left'
                inputType={ElementType.LABEL}
                helpText='<span> Instructions for this column - Third-Party Fees & Other Direct Costs</span>  <br/><br/><span>Include here all the other non-staff costs and fees that can be directly attributed to the specific function but that are not already included in the other functions listed. (e.g., do not include accommodation costs except in the accommodation line) These may include, but are not limited to:</span><br/> <br/><span>• Consulting fees for projects attributable to the activity.</span><br/> <span>• Subscriptions, conferences, activity specific training.</span><br/> <span>• Office supplies and stationery.</span><br/> <span>• Travel.</span>'
              />
            </SurveyGridHeader>
            <SurveyGridBody>
              <SurveyGridRow styleName='noHoverEffect'>
                <SurveyElement
                  labelText='<b>Administration</b>'
                  inputType={ElementType.LABEL}
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.1'
                  labelText='Oversight of an outsourced administrator'
                  inputType={ElementType.LABEL}
                  helpText='Include here the costs and FTEs associated with the oversight of any third party administration provider (where that responsibility is a full-time role).  Responsibilities might include monitoring performance, awarding and negotiating contracts etc. '
                  name=''
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKFTEOutsourcedOversight'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKSalariesOutsourcedOversight'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKThirdOutsourcedOversight'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.2'
                  labelText='Outsourced administration - regular fees'
                  helpText="Where administration is outsourced, wholly or partly, include the outsourced provider's regular fees here. (Refer to '3. In-house Administration' for a definition of administration)"
                  inputType={ElementType.LABEL}
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='RegularThirdadministration'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.3'
                  labelText='In-house administration'
                  inputType={ElementType.LABEL}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEadministration'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesadministration'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMOutsourcedAdministration'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow styleName='noHoverEffect'>
                <SurveyElement
                  labelText='If you are able to breakdown your administration costs in 2 and 3 above between the following categories then please do so.'
                  inputType={ElementType.LABEL}
                  smallFont
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Contact centre (if you have one)'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.ContactCentre}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTECalls'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesCalls'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdCalls'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Member transactions'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={
                    PabsMoreInfoPanels.MemberTransactionsAndInteractions
                  }
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTETransactions'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesTransactions'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdTransactions'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Pensioner payroll'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.PensionerPayroll}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEPaying'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesPaying'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdPaying'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Mail room/imaging'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.MailRoomAndImaging}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEMail'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesMail'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdMail'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Communication'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.Communication}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTECommunication'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesCommunication'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdCommunication'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Scheme-wide processes'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.SchemeWideProcesses}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEProcesses'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesProcesses'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdProcesses'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Serving employers'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.ServingEmployers}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEEmployers'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesEmployers'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdEmployers'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Finance and accounting'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.FinanceAndAccounting}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEFinancial'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesFinancial'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdFinancial'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Technical, risk mgt, compliance, quality'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={
                    PabsMoreInfoPanels.TechnicalRiskMgtComplicanceQuality
                  }
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTERisk'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesRisk'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdRisk'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Other'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                  helpText={PabsMoreInfoPanels.Other}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEother'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesother'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdother'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Total'
                  inputType={ElementType.LABEL}
                  name=''
                  subQuestion
                />
                <SurveyElement
                  inputType={ElementType.CALCULATED}
                  format={NumberFormat.DECIMAL1}
                  formula='FTECalls+UKMFTETransactions+FTEPaying+FTEMail+FTECommunication+UKMFTEProcesses+FTEEmployers+UKMFTEFinancial+UKMFTERisk+UKMFTEother'
                  name='TotalCost1'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.CALCULATED}
                  name='TotalCost2'
                  formula='SalariesCalls+UKMSalariesTransactions+SalariesPaying+SalariesMail+SalariesCommunication+UKMSalariesProcesses+SalariesEmployers+UKMSalariesFinancial+UKMSalariesRisk+UKMSalariesother'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.CALCULATED}
                  name='TotalCost3'
                  formula='ThirdCalls+UKMThirdTransactions+ThirdPaying+ThirdMail+ThirdCommunication+UKMThirdProcesses+ThirdEmployers+UKMThirdFinancial+UKMThirdRisk+UKMThirdother'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>

              <SurveyGridRow styleName='noHoverEffect'>
                <SurveyElement
                  labelText='<b>Governance</b>'
                  inputType={ElementType.LABEL}
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.4'
                  labelText='Board/Trustee fees and expenses'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.BoardTrusteeFeesAndExpenses}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEboard'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesboard'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdboard'
                  format={NumberFormat.DECIMAL1}
                  placeholder='£'
                  pageName='Cost'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.5'
                  labelText='CEO, Secretariat, Strategy and Policy'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.CeoSecretariatStrategyAndPolicy}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEceo'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesceo'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdceo'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.6'
                  labelText='Legal'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.Legal}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTElegalonly'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalarieslegalonly'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdlegalonly'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.7'
                  labelText='Actuarial - valuation related'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.ActuarialValuationRelated}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEActuarialValuation'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesActuarialValuation'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdActuarialValuation'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.8'
                  labelText='Actuarial - other'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.ActuarialOther}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEActuarialOther'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesActuarialOther'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdActuarialOther'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.9'
                  labelText='External Audit'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.ExternalAudit}
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdaudit'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow styleName='noHoverEffect'>
                <SurveyElement
                  labelText='<b>Major Projects</b>'
                  inputType={ElementType.LABEL}
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.10'
                  labelText='Amortisation of capitalised projects'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={
                    PabsMoreInfoPanels.AmortisationOfCapitalisedProjects
                  }
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdAmort'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.11'
                  labelText="Major Projects (if you don't capitalise)"
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.MajorProjects}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEMPnotcap'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesMPnotcap'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdMPnotcap'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.12'
                  labelText='Outsourced administration - irregular fees'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={
                    PabsMoreInfoPanels.OutsourcedAdministrationIrregularFees
                  }
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='IrregularThirdadministration'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow styleName='noHoverEffect'>
                <SurveyElement
                  labelText='<b>Support Services</b>'
                  inputType={ElementType.LABEL}
                  pageName='Cost'
                />
                <SurveyElement />
                <SurveyElement />
                <SurveyElement />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.13'
                  labelText='Accommodation'
                  inputType={ElementType.LABEL}
                  name=''
                  pageName='Cost'
                  helpText={PabsMoreInfoPanels.Accommodation}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEBuilding'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesBuilding'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdBuilding'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.14'
                  labelText='Human Resources and Training'
                  inputType={ElementType.LABEL}
                  name=''
                  pageName='Cost'
                  helpText={PabsMoreInfoPanels.HumanResourcesAndTraining}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='FTEHR'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='SalariesHR'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='ThirdHR'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.15'
                  labelText='IT/IS (excluding major projects)'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.ItIs}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEit'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesit'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdit'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber='3.16'
                  labelText='Other Support Services'
                  inputType={ElementType.LABEL}
                  name=''
                  helpText={PabsMoreInfoPanels.OtherSupportServices}
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMFTEOtherSupport'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMSalariesOtherSupport'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  name='UKMThirdOtherSupport'
                  format={NumberFormat.DECIMAL1}
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  labelText='Total Administrative Expenses'
                  inputType={ElementType.LABEL}
                />
                <SurveyElement
                  name='FTEDB'
                  format={NumberFormat.DECIMAL1}
                  inputType={ElementType.CALCULATED}
                  formula='UKFTEOutsourcedOversight + UKMFTEadministration + UKMFTEboard + UKMFTEceo + UKMFTElegalonly + UKMFTEActuarialValuation + UKMFTEActuarialOther + FTEMPnotcap + FTEBuilding + FTEHR + UKMFTEit + UKMFTEOtherSupport'
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  name='totalbenefitCost2'
                  format={NumberFormat.DECIMAL1}
                  inputType={ElementType.CALCULATED}
                  formula='UKSalariesOutsourcedOversight + UKMSalariesadministration + UKMSalariesboard + UKMSalariesceo + UKMSalariesLegalOnly + UKMSalariesActuarialValuation + UKMSalariesActuarialOther + SalariesMPnotcap + SalariesBuilding + SalariesHR + UKMSalariesit + UKMSalariesOtherSupport'
                  pageName='Cost'
                  placeholder='£'
                />
                <SurveyElement
                  name='totalbenefitCost'
                  format={NumberFormat.DECIMAL1}
                  inputType={ElementType.CALCULATED}
                  formula='UKThirdOutsourcedOversight + RegularThirdadministration + UKMOutsourcedAdministration + UKMThirdboard + UKMThirdceo + UKMThirdLegalOnly + UKMThirdActuarialValuation + UKMThirdActuarialOther + UKMThirdaudit + ThirdAmort + ThirdMPnotcap + IrregularThirdadministration + ThirdBuilding + ThirdHR + UKMThirdit + UKMThirdOtherSupport'
                  pageName='Cost'
                  placeholder='£'
                />
              </SurveyGridRow>
            </SurveyGridBody>
          </SurveyElement>
          <SurveyElement
            questionNumber='4'
            labelText="What was the total employer contribution to pension plan(s) in £000s for the staff included in the table above (i.e., the total pension contribution included in 'Staff Salaries & Benefits')?"
            name='UKCostERContributions'
            inputType={ElementType.NUMBER}
            format={NumberFormat.DECIMAL1}
            placeholder='£'
            pageName='Cost'
          />
          <SurveyElement
            questionNumber='5'
            labelText="If you put any costs in 16. 'Other Support Services' in the table above, describe below."
            inputType={ElementType.TEXTAREA}
            name='UKOtherCostsDescr'
            pageName='Cost'
          />
          <SurveyElement
            questionNumber='6'
            labelText="If you had costs for either 11.'Major Projects' or 12.'Outsourced administration - irregular', describe below:"
          />
          <SurveyElement inputType='grid' styleName={'specialCostTable'}>
            <SurveyGridHeader>
              <SurveyElement
                labelText='Description'
                inputType={ElementType.LABEL}
              />
            </SurveyGridHeader>

            <SurveyGridBody>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKOtherCostsDescribeA'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKOtherCostsDescribeB'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKOtherCostsDescribeC'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKOtherCostsDescribeD'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKOtherCostsDescribeE'
                />
              </SurveyGridRow>
            </SurveyGridBody>
          </SurveyElement>

          <SurveyElement
            questionNumber='7'
            labelText='Does your sponsoring employer (or another government department), provide any of the following free or on non-commercial terms to the scheme? (i.e., the costs are not captured in the table above.)'
          />
          <SurveyElement
            inputType={ElementType.RADIOBUTTON}
            questionNumber='7.a'
            labelText='Accommodation?'
            name='UKFreeAccommodationyn'
            options={SelectCombos.YES_NO}
            subQuestion
            pageName='Cost'
          />
          <SurveyElement
            inputType={ElementType.RADIOBUTTON}
            questionNumber='7.b'
            labelText='Pensioner payroll?'
            name='UKFreePensionerPayrollyn'
            options={SelectCombos.YES_NO}
            subQuestion
            pageName='Cost'
          />
          <SurveyElement
            inputType={ElementType.RADIOBUTTON}
            questionNumber='7.c'
            labelText='IT support, hardware or software?'
            name='UKFreeItyn'
            options={SelectCombos.YES_NO}
            subQuestion
            pageName='Cost'
          />
          <SurveyElement
            inputType={ElementType.RADIOBUTTON}
            questionNumber='7.d'
            labelText='Human resources?'
            name='UKFreeHryn'
            options={SelectCombos.YES_NO}
            subQuestion
            pageName='Cost'
          />
          <SurveyElement
            inputType={ElementType.RADIOBUTTON}
            questionNumber='7.e'
            labelText='Print and design facilities?'
            name='UKFreePrintyn'
            options={SelectCombos.YES_NO}
            subQuestion
            pageName='Cost'
          />

          <SurveyElement
            questionNumber='8'
            labelText='List any activities that you believe may have caused you to spend more than you normally spend, or more than other schemes, internally or externally, on governance in the year. These may include corporate transactions, high numbers of meetings, covenant issues, trustee elections etc.'
          />
          <SurveyElement inputType='grid' styleName={'specialCostTable'}>
            <SurveyGridHeader>
              <SurveyElement
                labelText='Description'
                inputType={ElementType.LABEL}
              />
            </SurveyGridHeader>

            <SurveyGridBody>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKMoreWorkDescA'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKMoreWorkDescB'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKMoreWorkDescC'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKMoreWorkDescD'
                />
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  inputType={ElementType.TEXT}
                  name='UKMoreWorkDescE'
                />
              </SurveyGridRow>
            </SurveyGridBody>
          </SurveyElement>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
};